export const API_DOMAIN = 'http://127.0.0.1:5000/'
